import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Inject, PieSeries, AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, AccumulationLegend, AccumulationTooltip, AccumulationDataLabel } from '@syncfusion/ej2-react-charts';
import { PMReportSummaryView } from '../../../../services/ReportingService';

interface PMCostBreakdownChartProps {
  summaryData: PMReportSummaryView;
}

const PMCostBreakdownChart: React.FC<PMCostBreakdownChartProps> = ({ summaryData }) => {
  const hasData = summaryData.totalLaborCost > 0 || summaryData.totalPartsCost > 0 || summaryData.totalVendorCost > 0;

  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
          Cost Breakdown
        </Typography>
        {hasData ? (
          <AccumulationChartComponent
            id="pm-cost-breakdown"
            tooltip={{ enable: true, format: '${point.x}: $${point.y}' }}
            height="300px"
          >
            <Inject services={[PieSeries, AccumulationLegend, AccumulationTooltip, AccumulationDataLabel]} />
            <AccumulationSeriesCollectionDirective>
              <AccumulationSeriesDirective
                dataSource={[
                  { category: 'Labor', cost: summaryData.totalLaborCost },
                  { category: 'Parts', cost: summaryData.totalPartsCost },
                  { category: 'Vendor', cost: summaryData.totalVendorCost },
                ]}
                xName="category"
                yName="cost"
                type="Pie"
                innerRadius="40%"
                dataLabel={{ visible: true, position: 'Outside', name: 'category' }}
              />
            </AccumulationSeriesCollectionDirective>
          </AccumulationChartComponent>
        ) : (
          <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="body2" color="#64748b">
              No data available
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default PMCostBreakdownChart;
